
import { NodeData_PaymentLink, NodeInterface, NodeType, PaymentSessionMode, VarKey } from "@swivl-mono/types";
import { Dropdown } from "@swivl-mono/ui";
import UserVariablesDropdown from "../../../../Components/Dropdowns/UserVariablesDropdown/UserVariablesDropdown";

import TabNodeLayoutData from "../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "./NodePanel";
import { RandomId } from "@swivl-mono/helpers";


const PaymentLinkNode = {
  Type: NodeType.PaymentLink,
  Empty: function () {
    const node: NodeData_PaymentLink = {
      id: RandomId(6),
      type: NodeType.PaymentLink,
      saveToVar: VarKey.UserShortURL,
      expiresAfterInMinutes: 30,
      mode: PaymentSessionMode.LIVE,
      goto: "",
    }

    return node;
  },
  PlumbData: function (_node: NodeInterface) {
    const node = _node as NodeData_PaymentLink;

    return TabNodeLayoutData({
      node: node,
      title: "Payment Link",
      body: "",
      baseWidth: 300,
      tabs: [{
        "id": "goto",
        "source": "goto",
        "target": node.goto,
      }]
    });
  },

  InspectorPanel: class InputInspectorPanel extends NodePanel {
    render() {
      const node = this.props.node as NodeData_PaymentLink;

      return <div>
        <div className="panel message_panel">
          <InspectorNodeHeader title="Validation" />
          <label>Payment Link Generation</label>
          <br />
          <label>Save Payment Link To</label>
          <UserVariablesDropdown
            onChange={this.onChange}
            skipUserId={true}
            name={"saveToVar"}
            value={node.saveToVar}
          />
          <label>Expires After</label>
          <Dropdown
            name="expiresAfterInMinutes"
            value={node.expiresAfterInMinutes || 0}
            onChange={this.onChange}
            options={[
              { value: undefined, label: "No Expiration" },
              { value: 1, label: "1 Minute" },
              { value: 5, label: "5 Minutes" },
              { value: 15, label: "15 Minutes" },
              { value: 30, label: "30 Minutes" },
            ]}
          />
          <label>Mode</label>
          <Dropdown
            name="mode"
            value={node.mode || PaymentSessionMode.LIVE}
            onChange={this.onChange}
            options={[
              { value: PaymentSessionMode.LIVE, label: "Live" },
              { value: PaymentSessionMode.TEST, label: "Test" },
            ]}
          />

        </div>
        <InspectorFooter deleteNode={this.deleteNode} node={node} />
      </div>

    }
  }
}
export default PaymentLinkNode;
